import { Overlay, useTitle } from "modules/common";
import React from "react";

export const MySensorics: React.FC = () => {
    useTitle("Moja senzorika - eSavjetnik");

    return (
        <Overlay
            containerClass="agroclimaticStations-overlay"
            fullScreenInitially
            view={{
                title: "Moja senzorika",
                source: "moja-senzorika",
            }}
        />
    );
};
